import React, {Component, Fragment} from 'react';
import './PCBQuotationImage.css';
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import InitialQuotationState from "../../InitialQuotationState";

const DetectionNotice = (props) => {


    let width = props.imageData.width;
    let length = props.imageData.length;

    let inchPerMm = 0.0393701;

    width = (width * inchPerMm).toFixed(2);
    length = (length * inchPerMm).toFixed(2);

    if(InitialQuotationState.lang === "ja"){
        return(
            props.imageData.width +"mm X " + props.imageData.length + "mm の "+props.imageData.layers+"層基板が検出されました。"
        );
    }
    else{
        return(
            "Detected "+props.imageData.layers + " layer board of " +props.imageData.width +" x " + props.imageData.length + "mm ("+width+"x"+length+"inches)"
        );
    }
};

class PCBQuotationImage extends Component {

    constructor(props) {
        super(props);
        this.onBackToUploadClick = this.onBackToUploadClick.bind(this);
        this.cartItemDto = this.cartItemDto.bind(this);
    }

    onBackToUploadClick = () => {
        window.location.reload();
    };

    cartItemDto=(gerberDto_imageUrlTop)=>{
        InitialQuotationState.temGerberDto=gerberDto_imageUrlTop;
        InitialQuotationState.temGerberDtoData=this.props.imageData;
        localStorage.setItem("igd", gerberDto_imageUrlTop);
        localStorage.setItem("igdto", JSON.stringify(this.props.imageData));

    };

    render() {

        const goTo = {
            pathname: '/gerber_viewer',
            imageUrl: this.props.imageData.jlcpcbGerberReviewResultDto && this.props.imageData.jlcpcbGerberReviewResultDto.result !== null ? this.props.imageData.jlcpcbGerberReviewResultDto.result.url : "",
            // imageUrl: this.props.imageUrl,
            imageData: this.props.imageData,
            fileUrl: this.props.fileUrl
        };


        return (
            <Fragment>
                {this.props.imageData.layers !== undefined && this.props.imageData.layers !== 0 && this.props.imageData.length !== 0 && this.props.imageData.width !== 0?
                    <div>
                    {/*<div className="quotation-image-caption">*/}
                    {/*    <FormattedMessage id="app.site.gerber.upload-finished"*/}
                    {/*                      defaultMessage="Your upload has finished processing.*/}
                    {/*Enter the project details below and we'll move on to*/}
                    {/*checking all the individual layers to make sure that they're correct."*/}
                    {/*                              description=""/>*/}

                    {/*        </div>*/}
                            <div className="quotation-image-caption-detection">
                                {(this.props.imageData.layers !== undefined && this.props.imageData.layers !== 0) ?
                                    <DetectionNotice imageData={this.props.imageData}/> : ""
                                }
                            </div>
                            <div className="col-md-12 image-row">
                                {/*<img className="gerber-image-quotation-form" src={this.props.imageUrl}/>*/}
                                <div className="col-md-6 custom-col-6 pcb-image-view text-center">
                                    <img width={250} src={this.props.imageData.imageUrlTopEncoded}
                                         className="responsive-gerber-image"/>
                                </div>
                                <div className="col-md-6 custom-col-6 pcb-image-view text-center">
                                    <img width={250} src={this.props.imageData.imageUrlBottomEncoded}
                                         className="responsive-gerber-image"/>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6 custom-col-6 resp-to-back-to-upload">
                                    <div className="back-to-upload-file">
                                        <p className="back-to-upload text-primary" onClick={this.onBackToUploadClick}>
                                            &lt;&lt;<FormattedMessage id="app.site.gerber.review.back"
                                                                      defaultMessage="Back to upload file"
                                                                      description=""/>
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6 custom-col-6 resp-to-gerber-viewer">
                                    <div className="to-gerber-review pull-right">
                                        {/*<Link to={goTo}*/}
                                        {/*      onClick={()=>this.cartItemDto(this.props.imageData.imageUrlTop)}*/}
                                        {/*      target="_blank"*/}
                                        {/*      className="back-to-upload text-primary">*/}
                                        {/*    <FormattedMessage id="app.site.gerber.review"*/}
                                        {/*                      defaultMessage="To Gerber Viewer"*/}
                                        {/*                      description=""/> &gt; &gt;*/}

                                        {/*</Link>*/}
                                    </div>
                                </div>
                            </div>
                        </div> : ""
                    }
            </Fragment>
        );
    }
}

export default PCBQuotationImage;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/PCBQuotationForm/PCBQuotationImage/PCBQuotationImage.js